/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA all-reviews React view (standalone)
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorReviewsRoute extends Route {
  queryParams = {
    page: { refreshModel: false },
    perPage: { refreshModel: false },
    reviewStatus: { refreshModel: false },
    reviewerId: { refreshModel: false },
    revieweeId: { refreshModel: false },
  };

  analytics = {
    section: 'standalone',
    place: 'monitor.reviews',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorReviewsRoute, {
  overrideRenderTemplate: false,
});
